import { Component, Inject } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

export interface GainsSuccessModalData {
  /** Bold heading shown under the success icon. */
  title: string;
  /** Supporting line explaining what was saved. */
  message: string;
  /** Optional label for the dismiss button (defaults to "Done"). */
  buttonLabel?: string;
}

/**
 * Reusable success confirmation modal — a centered card with a green success icon, a title, a
 * supporting message and a single dismiss button. Open it via {@link NzModalService.create} with
 * `nzContent: GainsSuccessModalComponent`, `nzFooter: null` and `nzData: GainsSuccessModalData`.
 */
@Component({
  standalone: false,
  selector: 'gains-success-modal',
  templateUrl: './gains-success-modal.component.html',
  styleUrl: './gains-success-modal.component.scss'
})
export class GainsSuccessModalComponent {
  constructor(
    private readonly _modal: NzModalRef,
    @Inject(NZ_MODAL_DATA) public data: GainsSuccessModalData
  ) {}

  get buttonLabel(): string {
    return this.data.buttonLabel ?? 'Done';
  }

  done(): void {
    this._modal.destroy();
  }
}
